module.exports = __webpack_public_path__ + "img/zanwu.3d4bc464.png";